import { api } from './auth.service';

const condicaoPagamentoService = {

  listar: async (status = null) => {
    const params = status ? { status } : {};
    const res = await api.get('/condicoes-pagamento', { params });
    return res.data;
  },

  buscarPorId: async (id) => {
    const res = await api.get(`/condicoes-pagamento/${id}`);
    return res.data;
  },

  incluir: async (dados) => {
    const res = await api.post('/condicoes-pagamento', dados);
    return res.data;
  },

  alterar: async (id, dados) => {
    const res = await api.put(`/condicoes-pagamento/${id}`, dados);
    return res.data;
  },

  alterarStatus: async (id, status, usuarioId) => {
    const res = await api.patch(`/condicoes-pagamento/${id}/status`, {
      status, usuario_id: usuarioId,
    });
    return res.data;
  },
};

export default condicaoPagamentoService;
